<template>
    <transition name="slide-fade">
        <tr role="row" @click.stop="accountStore.editUser(user)" class="cursor-pointer hover:bg-grey-100 group">
            <td :data-header="translate('beheerder')" class="mobile:hidden">
                <i v-if="user.isAdmin" class="fas fa-check text-grey-700"></i>
            </td>
            <td :data-header="translate('naam')">
                <b>{{user.name.trim() !== '' ? user.name : '-'}}</b>
            </td>
            <td :data-header="translate('status')">
                <span class="badge" :class="badgeClass">{{translate('tab_label_'+user.type)}}</span>
            </td>
            <td :data-header="translate('email')">
                {{user.email}}
            </td>
            <td :data-header="translate('laatst_actief')" class="tablet:hidden">
                <template v-if="user.lastActive !== 0">
                    {{ Date.fromHansDate(user.lastActive).toTimeAgo(false) }}
                </template>
                <template v-else>-</template>
            </td>
            <td :title="translate('aantal_mobile')" v-if="accountStore.isLoggedInAsAdmin && accountStore.canSeeMobiles" class="tablet:hidden">
                {{user.mobileInstalls.length}}
            </td>
            <td :title="translate('aantal_persoonlijke_alerts_gebruikt')" class="tablet:hidden">
                {{user.alertsUsage}}
            </td>
            <td class="mobile:hidden">
                <button class="btn btn-sm" v-if="accountStore.isLoggedInAsAdmin">{{translate('btn_edit')}}</button>
            </td>
            <td class="text-right tablet:hidden">
                <template v-if="accountStore.isLoggedInAsAdmin">
                    <button class="btn btn-sm btn-danger invisible group-hover:visible hover:bg-red-400 hover:text-white"
                            v-if="user.type === 'pending'"
                            v-on:click.prevent.stop="accountStore.removePendingUser(user)"
                            :title="translate('remove_user')">
                        <i class="fas fa-trash-alt"></i>
                    </button>

                    <button class="btn btn-sm btn-danger invisible group-hover:visible hover:bg-red-400 hover:text-white"
                            v-if="user.type === 'active'"
                            v-on:click.prevent.stop="accountStore.deactivateUser(user)"
                            :title="translate('deactivate_user')">
                        <i class="fas fa-user-lock"></i>
                    </button>

                    <button class="btn btn-sm btn-default invisible group-hover:visible"
                            v-if="user.type === 'deactivated'"
                            v-on:click.prevent.stop="accountStore.reactivateUser(user)"
                            :title="translate('reactivate_user')">
                        <i class="fas fa-user-check"></i>
                    </button>
                </template>
            </td>
        </tr>
    </transition>
</template>

<script lang="ts">
    import {defineComponent} from 'vue';
    import { User } from './types';
    import {useAccountStore} from "../store";
    
    export default defineComponent({
        name: 'user-row',
        props: {
            user: {
                type: Object as () => User,
                required: true
            }
        },
        data() {
            return {
                accountStore: useAccountStore()
            };
        },
        computed: {
            badgeClass(): string {
                let badgeClass = "";

                if (this.user.type === 'active')
                    badgeClass = "success";
                else if (this.user.type === 'pending')
                    badgeClass = "warning";
                else
                    badgeClass = "danger";

                return badgeClass;
            }
        },
    });
</script>